<script setup lang="ts">
import { Clapperboard } from '@lucide/vue'

defineProps<{ title: string, description?: string }>()
</script>

<template>
    <div class="min-h-72 flex flex-col items-center justify-center px-6 text-center">
        <div class="grid mb-5 size-15 place-items-center border border-[var(--c-border)] rounded-2xl bg-[var(--c-fill-subtle)] text-[var(--c-text-faint)]">
            <Clapperboard class="size-7" />
        </div>
        <h2 class="text-lg text-[var(--c-text)] font-700">
            {{ title }}
        </h2>
        <p v-if="description" class="mt-2 max-w-md text-sm text-[var(--c-text-muted)] leading-6">
            {{ description }}
        </p>
        <slot />
    </div>
</template>
